import { takeLatest, call, put } from 'redux-saga/effects'
import { getCandidateProfileMetadata } from '../apiModules/candidateProfileMetadata'
import { userSignOut } from '../apiModules/sessions'
import { errorHandler } from '../helpers/errorHelpers'
import * as sessionView from '../reducks/sessions'
import { showSystemError, hideSystemError } from '../components/SystemErrorRedux'

function* fetchMetadataSaga({ meta }) {
  try {
    yield put(hideSystemError())

    const response = yield call(getCandidateProfileMetadata, meta.candidateSlug)
    yield put(sessionView.fetchMetadataSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(sessionView.fetchMetadataError(error))
    yield put(showSystemError(error))
  }
}

function* signOutSaga() {
  try {
    yield put(hideSystemError())
    yield call(userSignOut)

    // Send the user back to the homepage
    window.location = '/'
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(showSystemError(error))
  }
}

export default function* watchSessionsSagas() {
  yield takeLatest(sessionView.FETCH_METADATA, fetchMetadataSaga)
  yield takeLatest(sessionView.SIGN_OUT, signOutSaga)
}
